import { authedJson } from '../api/client';

export interface ProjectMember {
  projectId: string;
  workspaceId: string;
  userId: string;
  displayName: string;
  email: string;
  capacityFraction: number;
  addedBy: string;
  addedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const projectMembersApi = {
  list: (workspaceId: string, projectId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ members: ProjectMember[] }>(
      `/workspaces/${workspaceId}/projects/${projectId}/members`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),

  add: (workspaceId: string, projectId: string, userId: string, capacityFraction: number, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<ProjectMember>(
      `/workspaces/${workspaceId}/projects/${projectId}/members`,
      { method: 'POST', body: JSON.stringify({ userId, capacityFraction }) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, projectId: string, userId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(
      `/workspaces/${workspaceId}/projects/${projectId}/members/${userId}`,
      { method: 'DELETE' },
      getToken,
      doRefresh,
    ),
};
